<template>
    <div class="container">
        <v-card>
            <v-card-title class="titulopagina">REPORTE ESTADO EQUIPOS</v-card-title>
        </v-card>

        <data-table-filtro class="mt-5" @editar="editar($event)"></data-table-filtro>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import Data_Table_Filtro from "@/components/shared/Data_Table_Filtro";

export default {
    data() {
        return {
            lista: [],
            cabeceras: [
                {
                    text: 'Fecha',
                    align: 'center',
                    sortable: true,
                    filterable: true,
                    busqueda:'',
                    value: 'estado_fecha'
                },
                {
                    text: 'Equipos Proceso',
                    align: 'center',
                    sortable: true,
                    filterable: true,
                    busqueda:'',
                    value: 'nombre_equipos_proceso'
                },
                {
                    text: 'Punto Medicion',
                    align: 'center',
                    sortable: true,
                    filterable: true,
                    busqueda:'',
                    value: 'nombre_punto',
                },
                {
                    text: 'Estado',
                    align: 'center',
                    sortable: true,
                    filterable: true,
                    busqueda:'',
                    value: 'estado'
                },
            ],
            acciones: [
                {}
            ]
        }
    },

    mounted() {
        this.cargarListado()
    },

    methods: {
        async cargarListado() {
            this.mostrarLoading({titulo: 'Cargando listado de equipos...', color: 'green'})

            let url = `${this.base_url}equipo_eventos/list`;
            await this.axios.get(url, this.headers).then((response) => {
                this.lista = response.data.data
                Event.$emit('inicializar_tabla', this.cabeceras, this.lista, this.acciones);
                this.ocultarLoading();
            }).catch((error) => {
                console.log('error', error);
                this.ocultarLoading();
            });
        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },

    computed: {
        ...mapState(['base_url', 'headers']),
    },

    components: {
        Data_Table_Filtro,
        'data-table-filtro':Data_Table_Filtro,
    }
}
</script>
<style scoped>
.table-dashboard th, td, tr {
    border: 1px solid #000;
}
</style>
